import { type PropsWithChildren } from 'react'

import { TaskQueryProvider } from '@/modules/tasks/query/task-query-context'
import { DefaultTaskFetchProvider } from '@/modules/tasks/service/task-fetch-context'

export type TaskModuleProps = PropsWithChildren<{ disableFetch?: boolean }>

export const TaskModule = ({ children, disableFetch }: TaskModuleProps) => {
  return (
    <DefaultTaskFetchProvider>
      <TaskQueryProvider enabled={!disableFetch}>{children}</TaskQueryProvider>
    </DefaultTaskFetchProvider>
  )
}
